import router from '@/router/index';
import {ProvidersNavigation,ResumeFsm} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  if(!tree)
  {
    let {addState,PseudoStateKind} = api;
    let here = parent.active;
    addState('init',here,PseudoStateKind.ShallowHistory);
  }
  else
  {
    let { messageIs, navigate } = api;
    let here = parent.active;

    here.init
      .to(here.providers);
    here.providers
    .to()
    .when(messageIs(ResumeFsm))
    .effect(()=>navigate(ProvidersNavigation));
  }
};
